// src/hooks/useSocket.js
import { useEffect, useRef } from 'react';
import { getSocket } from '../assets/js/common';  // ← your exact path

const useSocket = (event, callback) => {
  const callbackRef = useRef(callback);

  // Always keep latest callback without reconnecting
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const socket = getSocket();
    if (!socket || !event) return;

    const handler = (data) => callbackRef.current?.(data);

    socket.on(event, handler);

    return () => {
      socket.off(event, handler);
    };
  }, [event]);
};

export default useSocket;